import { useEffect, useRef, useState } from 'react'
import styled from '@emotion/styled'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import L4AppSideNav from './L4AppSideNav'
import { FusionInterfaceZIndex } from '@fusion-advantage/formrender'
import { updateRenderState } from '../../../lib/relay/updateRenderState'

interface SideNavContainerRootProps {
	left: number
}

const SideNavContainerRoot = styled.div<SideNavContainerRootProps>(({theme, left}) => ({
	zIndex: FusionInterfaceZIndex.SideNav,
	position: 'fixed',
	top: theme.statusBarHeightPx,
	left,
	transition: `left 0.16s ease-out`,
}))

const L4SideNavContainer = () => {
	const navRef = useRef<HTMLDivElement>(null)
	const open = useAppSelector(state => state.render.t1NavOpen)
	const backgroundTaps = useAppSelector(state => state.app.backgroundTaps)
	const dispatch = useAppDispatch()
	const [navWidth, setNavWidth] = useState(-1)
	const [navLeft, setNavLeft] = useState(-10000)

	useEffect(() => {
		if(navRef.current) {
			setNavWidth(navRef.current.offsetWidth)
		}
	})

	useEffect(() => {
		setNavLeft(open ? 0 : (navWidth * -1))
	}, [open, navWidth])

	useEffect(() => {
		dispatch(updateRenderState({t1NavOpen: false}))
	}, [dispatch, backgroundTaps])

	return (
		<SideNavContainerRoot left={navLeft}>
			<L4AppSideNav ref={navRef} />
		</SideNavContainerRoot>
	)
}

export default L4SideNavContainer
